












































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class ProgressRotate extends Vue {
  @Prop({ default: 0 }) score: Number
  @Prop({ default: 0 }) value: Number
  @Prop({ default: '' }) color: String
  @Prop({ default: 0 }) width: Number
  @Prop({ default: 0 }) size: Number
  @Prop({ default: 0 }) rotate: Number
  @Prop({ default: 'large' }) textSize: String
  @Prop({ default: true }) showLable: boolean
  @Prop({ default: false }) mirror: boolean
}
